import { Component, Input } from '@angular/core';

import { CoreMenuItem } from '@core/models';

@Component({
  standalone: false,
  selector: '[core-menu-vertical-item]',
  templateUrl: './item.component.html'
})
export class CoreMenuVerticalItemComponent {
  @Input()
  item: CoreMenuItem;
}
